import { render, staticRenderFns } from "./MedicoSolicitanteFormulario.vue?vue&type=template&id=e71aca66"
import script from "./MedicoSolicitanteFormulario.vue?vue&type=script&lang=js"
export * from "./MedicoSolicitanteFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports